import { useEffect, useRef } from "react";

// Exposes a fixed element's height as the `--action-bar-height` CSS variable
// so layouts can offset content and background around it.
export function useActionBarHeight<T extends HTMLElement>(
  variable = "--action-bar-height",
) {
  const ref = useRef<T>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const root = document.documentElement;
    const setHeight = () =>
      root.style.setProperty(variable, `${element.offsetHeight}px`);

    setHeight();
    const observer = new ResizeObserver(setHeight);
    observer.observe(element);

    return () => {
      observer.disconnect();
      root.style.removeProperty(variable);
    };
  }, [variable]);

  return ref;
}
